import { FormControl, Validators } from '@angular/forms';
import { TruckLoadingType } from '../../../administration';
import { NATURAL_NUMBER_PATTERN, TruckSize, TruckSizeUnion, UliActivityType } from '../../../../../common';

export class CalendarBasedUliCreationModel {
  dockId: number;
  dockName: string;
  compartmentId: number;
  in: boolean;
  out: boolean;
  loadingTypes: TruckLoadingType[];
  truckSizes: TruckSizeUnion[];
  overbooking: number;
  timeslotStart: Date;
  timeslotEnd: Date;

  constructor(params?: CalendarBasedUliCreationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CalendarBasedUliCreationFormModel {
  type: UliActivityType = UliActivityType.Outbound;
  compartmentId: number;
  dockId: number;
  dockName: string;
  loadingTypes: TruckLoadingType[] = [TruckLoadingType.End];
  truckSize: TruckSizeUnion = TruckSize.L;
  numberOfHandlingUnits: number;
  timeslotStart: Date;
  timeslotEnd: Date;
  durationInMins: number;

  constructor(params?: CalendarBasedUliCreationFormModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CalendarBasedUliCreationForm {
  constructor(
    model: CalendarBasedUliCreationFormModel,
    public type: FormControl<UliActivityType> = new FormControl(model.type, [Validators.required]),
    public loadingTypes: FormControl<TruckLoadingType[]> = new FormControl(model.loadingTypes, [Validators.required]),
    public truckSize: FormControl<TruckSizeUnion> = new FormControl(model.truckSize, [Validators.required]),
    public numberOfHandlingUnits: FormControl<number> = new FormControl(model.numberOfHandlingUnits, [
      Validators.required,
      Validators.pattern(NATURAL_NUMBER_PATTERN),
    ]),
    public timeslotStart: FormControl<Date> = new FormControl(model.timeslotStart, [Validators.required]),
    public timeslotEnd: FormControl<Date> = new FormControl(model.timeslotEnd, [Validators.required]),
    public compartmentId: FormControl<number> = new FormControl(model.compartmentId),
    public dockId: FormControl<number> = new FormControl(model.dockId),
    public durationInMins: FormControl<number> = new FormControl(model.durationInMins),
    public dockName: FormControl<string> = new FormControl(model.dockName),
  ) {}
}
